import React from "react"
import classNames from "classnames"

import { SECTION_NAMES } from "common/sectionNames"

import styles from "./ProgramSection.module.scss"
import commonStyles from "../../common/commonStyles.module.scss"

export default ({ onRef }) => (
  <div
    id={SECTION_NAMES.PROGRAM}
    ref={onRef}
    className={classNames(commonStyles.sectionWrapper, styles.sectionWrapper)}
  >
    <h2 className={classNames(commonStyles.title, styles.title)}>
      Jedes Programm eine eigene Welt
    </h2>
    <div className={styles.content}>
      <div className={styles.programs}>
        {/* Program 1 */}
        <p className={styles.date}>Sonntag, 21. Juni 2026</p>
        <div>
          18 Uhr Bernardisaal, Stift Stams.
          <br />
          <br />
          (Ab 17:15 laden wir Sie auf einen Apero zur Einstimmung.)
        </div>
        <br />
        <div>
          <div>
            Musik von{" "}
            <span className={styles.composer}>
              J.&thinsp;S. Bach, Steve Reich, Hubert Mittermayer Nesterovskiy
              u.&thinsp;a.
            </span>{" "}
            mit Texten von <span className={styles.composer}>N.&thinsp;N.</span>
          </div>
          <div className={styles.programFooter}>
            Es spricht Karl Markovics und spielen Mariya Nesterovska und Hubert
            Mittermayer Nesterovskiy.
          </div>
          {/* Program 2 */}
          <p className={styles.date}>Sonntag, 28. Juni 2026</p>
          <div>
            18 Uhr Bernardisaal, Stift Stams.
            <br />
            <br />
            (Ab 17:15 laden wir Sie auf einen Apero zur Einstimmung.)
          </div>
          <br />
          <div>
            <span className={styles.composer}>Alfred Schnittke </span> &ndash;
            Suite im alten Stil f&uuml;r Violine und Klavier (1977)
          </div>
          <div>
            <span className={styles.composer}>William Bradbury</span> &ndash;
            5&thinsp;&bull;&thinsp;4&thinsp;&bull;&thinsp;3&ensp;(except after
            C)&ensp;f&uuml;r Oboe, Klarinette und Fagott (2019)
          </div>
          <div>
            <span className={styles.composer}>Neil Rolnick</span> &ndash;
            Fiddle-Faddle f&uuml;r Violine und Elektronik (2003)
          </div>
          <div>
            <span className={styles.composer}>Wolfgang A. Mozart</span> &ndash;
            Quintett in Es-Dur KV 452&ensp;f&uuml;r Klavier, Oboe, Klarinette,
            Fagott und Horn
          </div>
        </div>
        <div className={styles.programFooter}>
          Es spielen Mariya Nesterovska, Nenad Le&#269;i&#263;, Giorgi
          Gvantseladze, Victor Rubio Aparici, Felipe Freitas und Hubert
          Mittermayer Nesterovskiy.
        </div>
        {/* Program 3 */}
        <p className={styles.date}>Sonntag, 5. Juli 2026</p>
        <div>
          18 Uhr Bernardisaal, Stift Stams.
          <br />
          <br />
          (Ab 17:15 laden wir Sie auf einen Apero zur Einstimmung.)
        </div>
        <br />
        <div>
          <span className={styles.composer}>Giovanni Platti</span> &ndash;
          Sonata &agrave; 3 in A-Dur, WD 683
        </div>
        <div>
          <span className={styles.composer}>Domenico Scarlatti</span> &ndash;
          Sonate in D-Dur, K.&thinsp;96 f&uuml;r Cembalo solo
        </div>
        <div>
          <span className={styles.composer}>Johann Ernst Galliard</span> &ndash;
          Sonate Nr.&thinsp;4 in e-moll f&uuml;r Fagott und Basso continuo
        </div>
        <div>
          <span className={styles.composer}>Benedetto Marcello</span> &ndash;
          Ciaccona
        </div>
        <div>
          <span className={styles.composer}>Joseph Bodin de Boismortier</span>{" "}
          &ndash; Sonate pour deux basses <nobr>in F-Dur,</nobr> op.&thinsp;14
          Nr.&thinsp;2
        </div>
        <div>
          <span className={styles.composer}>Johann Paul von Westhoff</span>{" "}
          &ndash; Sonate Nr.&thins;1 in a-moll f&uuml;r Violine und Basso
          continuo
        </div>
        <div>
          <span className={styles.composer}>Maurizio Cazzati</span> &ndash;
          Capriccio sopra sette note
        </div>
        <div>
          <span className={styles.composer}>
            Johann Caspar Ferdinand Fischer
          </span>{" "}
          &ndash; &bdquo;Unterschied zwischen einen rechten Violinist und
          gemeinen Bauern-Fiedler&ldquo; (aus Musicalische Fürsten-Lust)
        </div>
        <div className={styles.programFooter}>
          Es spielen Mariya Nesterovska, Hubert Mittermayer Nesterovskiy, Rafael
          Bonavita, J&aacute;n Krigovsk&yacute; und Fran&ccedil;ois Guerrier.
        </div>
        {/* Datenschutz */}
        <p className={styles.dataprotectionText}>
          Hinweis: Bei unseren Veranstaltungen werden Foto-, Video- und
          Tonaufnahmen gemacht. Mit Buchung Ihres Tickets erkl&auml;ren Sie sich
          mit unseren{" "}
          <a href="https://www.obertone.at/datenschutz.pdf">
            Datenschutzhinweisen
          </a>{" "}
          einverstanden.
        </p>
      </div>
    </div>
  </div>
)
